const sessionStorageUtils = {
  set: (key: string, value: number | string) => {
    const parseValue = typeof value === 'string' ? value : JSON.stringify(value);
    sessionStorage.setItem(key, parseValue);
    return value;
  },
  get: (key: string) => {
    const value = sessionStorage.getItem(key);
    return value;
  },
  remove: (key: string) => sessionStorage.removeItem(key)
};

export { sessionStorageUtils };
